// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2W4Um","productName":"Table_productName__hCFT1"};